import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { AddMfaMethodButton } from './add-mfa-method-button';
import { useMFAContext, VerificationContactMethod } from './mfa-context';

type SelectMFAMethodProps = {
  /** Does the user already MFA methods? This alters some copy. Default is false. */
  hasMFAMethods?: boolean;
};

export function SelectMFAMethod({ hasMFAMethods = false }: SelectMFAMethodProps) {
  const { t } = useTranslation('account');
  const addVerificationMethod = useMFAContext((ctx) => ctx.addVerificationMethod);
  const nextStep = useMFAContext((ctx) => ctx.nextStep);
  const flow = useMFAContext((ctx) => ctx.flow);

  const addMethod = useCallback(
    (method: VerificationContactMethod) => {
      addVerificationMethod(method);
      nextStep();
      flow.start().step(`select-mfa-method`, { method });
    },
    [addVerificationMethod, nextStep, flow]
  );

  return (
    <div>
      {hasMFAMethods && <Text size='medium'>{t('Add More Methods')}</Text>}
      <AddMfaMethodButton
        icon='message'
        label={hasMFAMethods ? t('Add Phone Number') : t('Send Code Via Text')}
        onClick={() => addMethod('sms')}
        id='add-mfa-method-sms-button'
      />
      <AddMfaMethodButton
        icon='email'
        label={hasMFAMethods ? t('Add Email') : t('Send Code Via Email')}
        onClick={() => addMethod('email')}
        id='add-mfa-method-email-button'
      />
    </div>
  );
}
